import {Box, Typography} from '@mui/material';

import {AppButtonVariant} from '@/app/shared-components';
import {AppButton} from '@/app/shared-components/AppButton/AppButton';
import {LetterAvatar} from '@/app/shared-components/LetterAvatar/LetterAvatar';
import {COLORS} from '@/styles/colors';

interface GroupMemberItemPropsButton {
  label: string;
  onClick: () => void;
}

interface GroupMemberItemProps {
  name: string;
  description?: string;
  isYou: boolean;
  isOwner: boolean;
  button?: GroupMemberItemPropsButton;
  memberNameRelated?: string;
}

export const GroupMemberItem: React.FC<GroupMemberItemProps> = ({
  name,
  description,
  isYou,
  isOwner,
  button,
  memberNameRelated,
}) => {
  return (
    <Box className="groups-dashboard-members-list-item">
      <LetterAvatar
        name={name}
        size={40}
        textColor={isOwner ? COLORS.INFO_BLUE : undefined}
        bgColor={isOwner ? COLORS.BACKGROUND_AVATAR_BLUE : undefined}
        badgeText={memberNameRelated}
      />

      <Box className="groups-dashboard-members-list-item-text">
        <Typography className="groups-dashboard-members-list-item-name">
          {name} {isYou && '(You)'}
        </Typography>

        {description && (
          <Typography className="groups-dashboard-members-list-item-description">
            {description}
          </Typography>
        )}
      </Box>
      {button && (
        <Box className="groups-dashboard-members-list-item-button">
          <AppButton
            id={`group-member-item-button-${name}`}
            label={button.label}
            onClick={button.onClick}
            variant={AppButtonVariant.onQuinary}
          />
        </Box>
      )}
    </Box>
  );
};
